import { render, staticRenderFns } from "./MarketHeader.vue?vue&type=template&id=782a5fa0&"
import script from "./MarketHeader.vue?vue&type=script&lang=js&"
export * from "./MarketHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports